import {Form as SimpleForm, FormProps} from 'react-final-form';
import arrayMutators from 'final-form-arrays';

const Form = <T, >({children, mutators, ...restProps}: FormProps<T>): JSX.Element => {
    const formProps = {
        mutators: {...mutators, ...arrayMutators},
        ...restProps
    };

    return <SimpleForm {...formProps}>{children}</SimpleForm>;
};

export default Form;
